<template>
  <div class="modal-window bds076">
    <header class="modal-header">
      <div class="tit">{{ $i18nUtil.trans("title.ReqFeedbackModal.001","피드백 요청") }}</div>
    </header>

    <div class="modal-content">
      <div class="txtr"><em>*</em> {{ $i18nUtil.trans("message.ReqFeedbackModal.011","필수 입력 필드") }}</div>
      <div class="box">
        <ul>
          <li class="row">
            <dl class="clear">
              <dt>{{ $i18nUtil.trans("title.ReqFeedbackModal.003","요청 기간") }}</dt>
              <dd>
                <div class="dropdown ty2 nosel">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" class="disabled ell-singleline">{{
                        $i18nUtil.getLanguage() !== 'ko' && currentQrt.qrtTopMsgEn != null ? currentQrt.qrtTopMsgEn : currentQrt.qrtTopMsg
                      }}</v-btn>
                    </template>
                    <div
                      class="dropdown-list-item"
                      v-for="(item, index) in qrtList"
                      :key="index"
                      :class="{ disabled: item.disabled }"
                      :disabled="item.disabled"
                    >
                      <div class="tit" :disabled="item.disabled">
                        <button
                          type="button"
                          class="ell-singleline"
                          :class="{
                            active: item.QRT_CD == currentQrt.qrtCd,
                            disabled: item.disabled,
                          }"
                          @click="
                            qrtChange(
                              item.QRT_CD,
                              item.disabled,
                              item.reqMsq,
                              $event
                            )
                          "
                        >
                          {{ $i18nUtil.getLanguage() !== 'ko' && item.QRT_TOP_MSG_EN != null ? item.QRT_TOP_MSG_EN : item.QRT_TOP_MSG }}
                        </button>
                      </div>
                    </div>
                  </v-menu>
                </div>
              </dd>
            </dl>
          </li>
          <li class="row">
            <dl class="clear">
              <dt>{{ $i18nUtil.trans("title.ReqFeedbackModal.004","보드명") }}</dt>
              <dd>
                <div class="txt">
                  {{ feedbackInfo.paperInfo.paperTitle }}
                </div>
                <div class="txt small" v-html="$i18nUtil.trans('message.ReqFeedbackModal.001','* 피드백 요청 시 보드 내용이 스냅샷으로 요청되며, 이후 업데이트 내용은 반영되지 않습니다.(할 일, 의사결정, 첨부파일, 의견, 최종결과물은 제외되며, 보드 내  파일은 별도 첨부 필요)')"></div>
              </dd>
            </dl>
          </li>
          <li v-if="tenantId != '203'" class="row">
            <dl class="clear">
              <!-- <dt v-if="tenantId == '418502'">연결된 Work</dt>
              <dt v-else>연결된 KR</dt> -->
              <dt>{{ $i18nUtil.trans("title.ReqFeedbackModal.005","연결된 KR") }}</dt>
              <dd>
                <div class="txt disabled" v-if="show">
                  {{ $i18nUtil.trans("message.ReqFeedbackModal.002","요청 분기 안에 보드와 연결된 KR이 없습니다.") }}
                </div>
                <div class="link-kr">
                  <div class="droplayer relative">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on"
                          >{{
                            currentQrt.qrtCd == null || paperKrLinkList.length == 0
                              ? $i18nUtil.trans("message.ReqFeedbackModal.012","요청 기간 안에 보드와 연결된 KR이 없습니다.")
                              : paperKrLinkList[0].okrTitle
                          }}
                          <span
                            class="num"
                            v-if="
                              currentQrt.qrtCd != null &&
                              paperKrLinkList.length > 0
                            "
                            >{{ paperKrLinkList.length }}</span
                          ></v-btn
                        >
                      </template>
                      <div class="dropdown-list">
                        <ul class="scroll">
                          <li
                            v-for="(item, index) in paperKrLinkList"
                            :key="index"
                          >
                            {{ item.okrTitle }}
                          </li>
                        </ul>
                      </div>
                    </v-menu>
                  </div>
                </div>
              </dd>
            </dl>
          </li>
          <li class="row">
            <dl class="clear">
              <dt>{{ $i18nUtil.trans("entity.cogroupUser.groupKbn") }}</dt>
              <dd>
                <div class="part-member-num">
                  <UserInfo
                    :userId="feedbackInfo.paperInfo.regUserId"
                    :userName="feedbackInfo.paperInfo.regUserName"
                    :userNameEn="feedbackInfo.paperInfo.regUserNameEn"
                    :userNameAfter="userNameAfter"
                    :userCount="feedbackInfo.paperUserList.userList.length"
                    :userCountAfter="userCountAfter"
                    :paperId="feedbackInfo.paperInfo.paperId"
                  />
                </div>
              </dd>
            </dl>
          </li>
          <li class="row">
            <dl class="clear">
              <dt><em>*</em> {{ $i18nUtil.trans("title.ReqFeedbackModal.007","피드백 답변자") }}</dt>
              <dd>
                <button
                  type="button"
                  class="btn-primary-smaller black"
                  @click="selectedAnswerer"
                >
                  {{ answerer.superior == null ? $i18nUtil.trans("title.ReqFeedbackModal.008","답변자 지정") : $i18nUtil.trans("title.ReqFeedbackModal.009","답변자 변경") }}
                </button>
                <div class="output">
                  <div class="scroll">
                    <div class="row clear">
                      <div class="tit">{{ $i18nUtil.trans("entity.user.manager","상위 관리자") }}</div>
                      <div class="txt">
                        {{
                          answerer.superior == null
                            ? $i18nUtil.trans("message.ReqFeedbackModal.003","상위관리자를 선택해주세요.")
                            : answererTxt.superior
                        }}
                      </div>
                    </div>
                    <div class="row clear" v-if="feedbackInfo.isBoardMember">
                      <div class="tit">{{ $i18nUtil.trans("entity.cogroupUser.groupKbn") }}</div>
                      <div class="txt">
                        {{
                          answerer.boardMember.length == 0
                            ? $i18nUtil.trans("message.ReqFeedbackModal.004","보드 멤버를 선택해주세요.")
                            : answererTxt.boardMember
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </dd>
            </dl>
          </li>
          <li class="row">
            <dl class="clear">
              <dt><em>*</em> {{ $i18nUtil.trans("title.ReqFeedbackModal.012","업무 난이도") }}</dt>
              <dd>
                <div class="dropdown ty2 nosel">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" class="disabled">{{
                        taskDiff == "3"
                          ? $i18nUtil.trans("entity.feedback.taskDiff.C3","상")
                          : taskDiff == "2"
                          ? $i18nUtil.trans("entity.feedback.taskDiff.C2","중")
                          : taskDiff == "1"
                          ? $i18nUtil.trans("entity.feedback.taskDiff.C1","하")
                          : $i18nUtil.trans("message.select","선택")
                      }}</v-btn>
                    </template>
                    <div class="dropdown-list">
                      <div class="dropdown-list-item">
                        <button type="button" @click="taskDiff = '3'">
                          {{ $i18nUtil.trans("entity.feedback.taskDiff.C3","상") }}
                        </button>
                      </div>
                      <div class="dropdown-list-item">
                        <button type="button" @click="taskDiff = '2'">
                          {{ $i18nUtil.trans("entity.feedback.taskDiff.C2","중") }}
                        </button>
                      </div>
                      <div class="dropdown-list-item">
                        <button type="button" @click="taskDiff = '1'">
                          {{ $i18nUtil.trans("entity.feedback.taskDiff.C1","하") }}
                        </button>
                      </div>
                    </div>
                  </v-menu>
                </div>
              </dd>
            </dl>
          </li>
          <li class="row">
            <dl class="clear">
              <dt v-html="$i18nUtil.trans('title.ReqFeedbackModal.014','피드백 요청내용')">
                <!-- <em>*</em> 피드백 요청<br />
                내용 -->
              </dt>
              <dd>
                <textarea
                  name=""
                  id=""
                  :placeholder="$i18nUtil.trans('message.placeholder.contents','내용을 간략하게 입력해주세요. (최소 입력글자 {cnt}자 이상)', {cnt: 5})"
                  v-model="feedbackReqMsg"
                ></textarea>
              </dd>
              <div class="error" v-if="error !== null">
                {{ error }}
              </div>
            </dl>
          </li>
          <li class="row">
            <dl class="clear">
              <dt>{{ $i18nUtil.trans("title.ReqFeedbackModal.018","첨부파일") }}</dt>
              <dd>
                <form style="display: none">
                  <input
                    multiple
                    type="file"
                    id="fileUpload"
                    @change="feedbackChangeFile()"
                    ref="feedbackUploadfile"
                  />
                </form>
                <div>
                  <button
                    type="button"
                    class="btn_link_add"
                    @click="$refs.feedbackUploadfile.click()"
                  >
                    {{ $i18nUtil.trans("button.fileUpload.pc","나의 PC 파일 추가") }}
                  </button>
                  <button
                    type="button"
                    class="btn_link_add"
                    @click="uploadBoardFile()"
                  >
                    {{ $i18nUtil.trans("title.FeedbackUploadFile.001","보드 내 최종결과물 추가") }}
                  </button>
                </div>
                <div class="attachfile_box">
                  <div class="scroll">
                    <div>
                      <div
                        class="file_row clear"
                        v-for="(item, index) in files"
                        :key="'files' + index"
                      >
                        <div
                          class="ell-singleline file_name"
                          :class="icoFile(item.name || item.fileName)"
                        >
                          {{ item.name || item.fileName }}
                        </div>
                        <div class="btn del">
                          <button
                            type="button"
                            class="btn_link_add del"
                            @click="confirmDelFile(item, index)"
                          >
                            <span>{{ $i18nUtil.trans("button.delete","삭제") }}</span>
                          </button>
                          <!-- <div class="droplayer icon more large right nosel">
                            <v-menu bottom left>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on">더보기</v-btn>
                              </template>
                              <div class="dropdown-list">
                                <div class="dropdown-list-item">
                                  <div class="tit">
                                    <button
                                      type="button"
                                      @click="confirmDelFile(item, index)"
                                    >
                                      파일 삭제
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </v-menu>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ref">
                  * {{ $i18nUtil.trans("message.ReqFeedbackModal.005","1개 파일당 150mb 이하, 전체 1G 이하만 업로드 가능합니다.") }}
                </div>
              </dd>
            </dl>
          </li>
        </ul>
      </div>
      <div class="ref">
        {{ $i18nUtil.trans("message.ReqFeedbackModal.006","피드백은 요청 기간별 한번만 요청가능하며, 이미 요청 했거나 피드백 신청 기간에 해당되지 않으면 요청 기간 선택을 할 수 없습니다.") }}
      </div>
    </div>
    <footer class="modal-footer">
      <button type="button" class="btn_ty1" @click="registSnapshot">
        {{ $i18nUtil.trans("button.reqFeedback","피드백 요청하기") }}
      </button>
    </footer>
  </div>
</template>
<script>
import axios from "axios";
import { mapState, mapActions, mapMutations } from "vuex";
import UserInfo from "@/components/cowork/common/user/UserInfo";
import ReqFeedBackAnswerer from "./ReqFeedBackAnswerer";
import FeedbackUploadFile from "./FeedbackUploadFile";
import EventBus from "@/js/eventbus/eventBus";
export default {
  // props: {
  //   modalInfo: {
  //     type: Object,
  //     required: true,
  //   },
  // },
  components: {
    UserInfo,
    ReqFeedBackAnswerer,
  },
  data() {
    return {
      /* tenantId */
      tenantId: localStorage.getItem("tenantId"),
      //스냅샷 id
      snapshotPaperId: "",
      // 성과 인터페이스용 파일목록
      feedbackFileList: [],
      error: null,
      feedbackReqMsg: "",
      //전체파일목록
      files: [],
      //산출물 파일목록
      boardFiles: [],
      //로컬파일목록
      localFiles: [],
      show: false,
      answerer: {
        superior: null,
        boardMember: [],
      },
      answererTxt: {
        superior: "",
        boardMember: "",
      },
      feedbackInfo: {
        paperInfo: {
          paperId: this.$route.params.paperId,
          paperTitle: "",
          regUserId: "",
          regUserName: "",
        },
        loginUserId: {},
        paperUserList: {
          userList: [],
        },
      },
      taskDiff: null,
      qrtList: [],
      userNameAfter: this.$i18nUtil.trans("message.ReqFeedbackModal.014","(생성자)"),
      userCountAfter: "",
      paperKrLinkList: [],
      paperKrLinkCount: 0,
      currentQrt: {
        qrtCd: null,
        qrtTopMsg: null,
        qrtTopMsgEn: null,
      },
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      changeAnswerer: 0,
    };
  },
  watch: {
    feedbackReqMsg: function () {
      let byte = 0;

      for (let i = 0; i < this.feedbackReqMsg.length; ++i) {
        // 기본 한글 2바이트 처리
        this.feedbackReqMsg.charCodeAt(i) > 127 ? (byte += 2) : byte++;
      }
      if (byte > 4000) {
        this.error = this.$i18nUtil.trans("UB008", {
          textLength: this.feedbackReqMsg.length,
          byteLength: byte,
          maxByteLength: 4000,
        });
      } else if (this.feedbackReqMsg.length < 5) {
        this.error = this.$i18nUtil.trans("message.ReqFeedbackModal.013","5자 이상 입력해주세요");
      } else {
        this.error = null;
      }
    },
  },
  created() {
    let body = document.querySelector("body");
    body.classList.add("terms");
    body.style.overflow = "hidden";
    EventBus.$off("registAnswerer");
    EventBus.$off("registFeedbackBoardFile");
    EventBus.$on("registAnswerer", (payload) => {
      this.changeAnswerer += 1;
      this.answererTxt.superior = "";
      this.answererTxt.boardMember = "";
      
      if(payload.superior != null) {
        if(this.$i18nUtil.getLanguage() === 'ko') {
          this.answererTxt.superior = payload.superior.ANSWERER_NAME + "(" + payload.superior.ANSWERER_DEPT_NAME + ")";
        }else{
          let name = payload.superior.ANSWERER_NAME_EN != null ? payload.superior.ANSWERER_NAME_EN : payload.superior.ANSWERER_NAME;
          let dept = payload.superior.ANSWERER_DEPT_NAME_EN != null ? payload.superior.ANSWERER_DEPT_NAME_EN : payload.superior.ANSWERER_DEPT_NAME;
          this.answererTxt.superior += name;
          this.answererTxt.superior += "(" + dept + ")";
        }
      }

      if (payload.boardMember.length > 0) {
        payload.boardMember.forEach((element, index, array) => {
          if(this.$i18nUtil.getLanguage() === 'ko') {
            this.answererTxt.boardMember += element.userName + "(" + element.deptName + ")";
          }else{
            let dept = element.deptNameEn != null ? element.deptNameEn : element.deptName
            this.answererTxt.boardMember 
              += element.userNameEn != null ? element.userNameEn : element.userName
            this.answererTxt.boardMember 
              += "(" + dept + ")";
          }

          if (index != array.length - 1) {
            this.answererTxt.boardMember += ",";
          }
        });
      }
      this.answerer = payload;
    });
    EventBus.$on("registFeedbackBoardFile", (payload) => {
      this.boardFiles = payload;
      for (let i = 0; i < payload.length; i++) {
        this.files.push(payload[i]);
      }
      console.log(this.files);
    });
    this.getInitFeedbackInfo();
  },
  methods: {
    ...mapActions("modals", ["showModal", "showToast"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),

    getInitFeedbackInfo() {
      let url = "/api/copaper/feedback/getFeedbackInfo";
      let param = {
        paperId: this.feedbackInfo.paperInfo.paperId,
      };
      let obj = this;
      axios
        .post(url, param)
        .then((res) => {
          if (res.data.errorCode) {
            console.log("getFeedbackInfo error", res.data.errorCode);
            // return;
          } else {
            obj.feedbackInfo = res.data.result;
            obj.getBoardKrQrtList();
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 보드 OKR 분기/KR 리스트 조회 */
    getBoardKrListByQrtCd(qrtCd) {
      let url = "/api/copaper/okr/getMyPaperOkrList";
      let param = {
        paperId: this.feedbackInfo.paperInfo.paperId,
        qrtCd: qrtCd,
      };
      let obj = this;
      axios
        .post(url, param)
        .then((res) => {
          if (res.data.errorCode) {
            console.log("getMyPaperOkrList error", res.data.errorCode);
            // return;
          } else {
            obj.paperKrLinkList = res.data.result.paperKrLinkList;
            obj.paperKrLinkCount = res.data.result.paperKrLinkCount;
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    getBoardKrQrtList() {
      let url = "/api/copaper/okr/getMyPaperQrtList";
      let param = {
        paperId: this.feedbackInfo.paperInfo.paperId,
      };
      let obj = this;
      axios
        .post(url, param)
        .then((res) => {
          if (res.data.errorCode) {
            console.log("getMyPaperQrtList error", res.data.errorCode);
          } else {
            let resQrtList = res.data.result.qrtList;
            if (resQrtList && resQrtList.length > 0) {
              resQrtList.forEach((qrt) => {
                qrt.disabled = false;
              });
            }
            // console.log(resQrtList);
            obj.qrtList = resQrtList;
            obj.paperKrLinkList = res.data.result.paperKrLinkList;
            obj.paperKrLinkCount = res.data.result.paperKrLinkCount;

            obj.currentQrt.qrtTopMsg = obj.$i18nUtil.trans("message.select","선택");
            if (obj.qrtList == null || obj.qrtList.length == 0) {
              obj.paperKrLinkCount = 0;
              obj.paperKrLinkList = [];
            }
          }
          this.getFeedbackReqYn();
        })
        .catch((err) => {
          console.log("getMyPaperQrtList axios error", err);
          //obj.showAlertDialog('OKR 연동에 실패했습니다.');
        });
    },
    getFeedbackReqYn() {
      let obj = this;
      let list = obj.qrtList;
      let axiosArr = [];
      let axiosData = [];
      if (list) {
        for (let inx = 0; inx < list.length; inx++) {
          let url = "/api/copaper/okr/getFeedbackReqYn";
          let data = {
            paperId: this.feedbackInfo.paperInfo.paperId,
            qrtCd: list[inx].QRT_CD,
            locale: this.$i18nUtil.getLanguage()
          };
          axiosArr.push(axios.post(url, data, { responseType: "json" }));
          axiosData.push(data);
        }
      }
      console.log(axiosArr);
      if (axiosArr.length > 0) {
        axios
          .all(axiosArr)
          .then(
            axios.spread((...responses) => {
              if (responses.length > 0) {
                responses.forEach((_res, indx) => {
                  if (_res && _res.status == 200) {
                    const reqYn = _res.data.result.FEEDBACK_REQ_YN;
                    const reqMsq = _res.data.result.FEEDBACK_REQ_MSG;
                    const targetQrtCd = axiosData[indx].qrtCd;
                    if (obj.qrtList && obj.qrtList.length > 0) {
                      obj.qrtList.forEach((qrt) => {
                        if (qrt.QRT_CD == targetQrtCd) {
                          qrt.disabled = reqYn == "0" ? true : false;
                          qrt.reqMsq = reqMsq;
                        }
                      });
                    }
                  }
                });
              }
            })
          )
          .catch((errors) => {
            console.log("getFeedbackReqYn axios error", errors);
            //obj.showAlertDialog('OKR 연동에 실패했습니다.');
          });
      }
      if (this.tenantId != "418502") {
        this.getInitAnswerer();
      };
    },
    getInitAnswerer() {
      let obj = this;
      let okrIds = "";
      let qrtCd = obj.currentQrt == null ? obj.qrtList[0].QRT_CD : obj.currentQrt.qrtCd; // obj.qrtList[0].QRT_CD;
      let url = "/api/copaper/okr/getOkrSuperiorList";
      let param = {
        paperId: this.feedbackInfo.paperInfo.paperId,
        qrtCd: qrtCd,
        okrIds: okrIds,
      };
      
      axios
        .post(url, param)
        .then((res) => {
          if (res.data.errorCode) {
            console.log("getOkrSuperiorList error", res.data.errorCode);
            // return;
          } else {
            if(res.data.result.length > 0) {
              const result = res.data.result[0];
              obj.answerer.superior = result;
              if(obj.$i18nUtil.getLanguage() === 'ko') {
                obj.answererTxt.superior = result.ANSWERER_NAME + "(" + result.ANSWERER_DEPT_NAME + ")";
              }else {
                let name = result.ANSWERER_NAME_EN != null ? result.ANSWERER_NAME_EN : result.ANSWERER_NAME;
                let dept = result.ANSWERER_DEPT_NAME_EN != null ? result.ANSWERER_DEPT_NAME_EN : result.ANSWERER_DEPT_NAME;
                obj.answererTxt.superior = name + "(" + dept + ")";
              }
            }else {
              obj.answerer.superior = null;
              obj.answererTxt.superior = "";
            }
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });

    },
    qrtChange(qrtCd, disabled, reqMsq, event) {
      this.currentQrt.qrtCd = qrtCd;
      this.currentQrt.disabled = disabled;
      this.currentQrt.reqMsq = reqMsq;
      this.currentQrt.qrtTopMsg = event.target.innerText;

      if (this.currentQrt.qrtCd == null) {
        this.toastInfo.message = this.$i18nUtil.trans("message.ReqFeedbackModal.007","연결된 KR이 없습니다.");
        this.showToast(this.toastInfo);
        return;
      } else {
        if (disabled) {
          this.toastInfo.message = this.currentQrt.reqMsq;
          this.showToast(this.toastInfo);
          return;
        } else {
          this.getBoardKrListByQrtCd(qrtCd);
        }
        this.getInitAnswerer(); // 2021.06.24 분기 변경시마다 상위관리자 호출
      }
    },
    selectedAnswerer() {
      let obj = this;
      if (this.currentQrt.qrtCd == null) {
        obj.showAlertDialog(obj.$i18nUtil.trans("AB065"));
        return;
      } else {
        const modalInfo = {
          title: obj.$i18nUtil.trans("title.ReqFeedBackAnswerer.001","피드백 답변자 지정"),
          width: "500px",
          obj: this.$modal,
          userList: this.feedbackInfo.paperUserList.userList,
          paperId: this.feedbackInfo.paperInfo.paperId,
          qrtCd: this.currentQrt.qrtCd,
          userId: this.feedbackInfo.loginUserId,
          isBoardMember: this.feedbackInfo.isBoardMember,
          paperKrLinkList: this.paperKrLinkList,
          component: ReqFeedBackAnswerer,
          answerer: this.answerer,
          changeAnswerer: this.changeAnswerer
        };
        this.showModal(modalInfo);
      }
    },
    registSnapshot() {
      const obj = this;
      if (this.tenantId == "418502") {
        if (this.currentQrt.qrtCd == null) {
          obj.showAlertDialog(obj.$i18nUtil.trans("AB065"));
          return;
        }
      } else {
        if (this.qrtList.length != 0 && this.currentQrt.qrtCd == null) {
          obj.showAlertDialog(obj.$i18nUtil.trans("AB065"));
          return;
        }
      }
      if (this.currentQrt.disabled) {
        this.toastInfo.message = this.currentQrt.reqMsq;
        this.showToast(this.toastInfo);
        return;
      }
      if(this.tenantId === "432") {
        if (this.answerer.superior == null && this.answerer.boardMember.length == 0) {
          obj.showAlertDialog(obj.$i18nUtil.trans("message.ReqFeedbackModal.015", "피드백 답변자는 1명 이상 선택해주세요."));
          return;
        }
      }else {
        if (this.answerer.superior == null) {
          obj.showAlertDialog(obj.$i18nUtil.trans("AB043"));
          return;
        }
      }
      if (this.taskDiff == null) {
        obj.showAlertDialog(obj.$i18nUtil.trans("AB044"));
        return;
      }
      if (this.error !== null) {
        return ;
      }

      let addPaperUserList = [];
      //보드멤버 담당자 추가
      this.answerer.boardMember.forEach((item) => {
        let addPaperUser = {};
        addPaperUser.paperUserId = item.userId;
        addPaperUser.userGrade = "MEMBER";
        addPaperUser.userKbn = "01";
        addPaperUserList.push(addPaperUser);
      });
      //상위관리자 담당자 추가
      if(this.answerer.superior != null) {
        const addSuperior = {
          paperUserId: this.answerer.superior.ANSWERER_ID,
          userGrade: "MEMBER",
          userKbn: "01",
        };
        addPaperUserList.push(addSuperior);
      }
      let reqData = {
        url: "/api/copaper/paper/genSnapShot",
        method: "post",
        params: {
          paperId: this.feedbackInfo.paperInfo.paperId,
          addPaperUserList: addPaperUserList,
        },
      };
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.snapshotPaperId = res.result.paperId;
            if (obj.localFiles.length > 0) {
              obj.uploadFeedbackFile();
            } else if (obj.boardFiles.length > 0) {
              obj.copyOutputToFeedback();
            } else {
              obj.requestFeedback();
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    requestFeedback() {
      let url = "/api/copaper/feedback/registFeedback";
      let memberList = [];
      let member = {};
      if(this.answerer.superior != null) {
        member.memberId = this.answerer.superior.ANSWERER_ID;
        member.memberName = this.answerer.superior.ANSWERER_NAME;
        member.memberNameEn = this.answerer.superior.ANSWERER_NAME_EN;
        member.memberDeptName = this.answerer.superior.ANSWERER_DEPT_NAME;
        member.memberDeptNameEn = this.answerer.superior.ANSWERER_DEPT_NAME_EN;
        member.upperManagerYn = "1";
        memberList.push(member);
      }
      this.answerer.boardMember.forEach((element) => {
        member = {};
        member.memberId = element.userId;
        member.memberName = element.userName;
        member.memberNameEn = element.userNameEn;
        member.memberDeptName = element.deptName;
        member.memberDeptNameEn = element.deptNameEn;
        member.upperManagerYn = "0";
        memberList.push(member);
      });
      let param = {
        paperId: this.feedbackInfo.paperInfo.paperId,
        qrtCd: this.currentQrt.qrtCd,
        paperTitle: this.feedbackInfo.paperInfo.paperTitle,
        feedbackReqMsg: this.feedbackReqMsg,
        taskDiff: this.taskDiff,
        memberList: memberList,
        paperKrLinkList: this.paperKrLinkList,
        snapshotPaperId: this.snapshotPaperId,
        fileList: this.feedbackFileList,
      };
      let obj = this;

      axios
        .post(url, param)
        .then((res) => {
          if (res.data.errorCode) {
            console.log("getPaperUserList error", res.data.errorCode);
            if (res.data.errorCode === "OKR_303_ERROR") {
              obj.showAlertDialog(obj.$i18nUtil.trans("message.ReqFeedbackModal.016", "피드백 요청에 실패했습니다.\n파일용량 또는 피드백 본문 길이 등을 체크 후 다시 요청해주세요."));
              obj.hideLoadingbar();
            }
          } else { 
            window.opener.document.getElementById("isWindowPop").value =
              "close";
            obj.hideLoadingbar();
            window.close();
          }
        })
        .catch((err) => {
          console.log("registFeedback axios error", err);
        });
    },
    closePopup() {
      let body = document.querySelector("body");
      body.style.removeProperty("overflow");
      this.$emit("close");
    },
    uploadFeedbackFile() {
      const obj = this;
      let formData = new FormData();
      let header = {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.getItem("Authorization"),
      };
      for (let i = 0; i < this.localFiles.length; i++) {
        formData.append("files", this.localFiles[i]);
      }

      /* tiptap editor image groupId */
      formData.append("groupId", String(this.feedbackInfo.paperInfo.groupId));
      formData.append("paperId", String(this.feedbackInfo.paperInfo.paperId));
      formData.append("feedbackPaperId", this.snapshotPaperId);
      formData.append(
        "sharepointSiteId",
        String(this.feedbackInfo.paperInfo.sharepointSiteId)
      );
      axios
        .post("/api/cofile/paper/uploadFeedbackFile", formData, header)
        .then((res) => {
          if (res.data.errorCode !== null) {
            if (res.data.errorCode === "COFILE_FILE_UPLOAD_CAPACITY_EXCEEDED") {
              obj.hideLoadingbar();
              obj.showAlertDialog(obj.$i18nUtil.trans("AB108",{ limitSize: res.data.errorMessage /1024 /1024 }));
              return;
            }
          }else {
            let result = res.data.result;

            if (result.uploadFailList.length > 0) {
              let message = "";
              let length = 0;
              let itemMsg = "";
              result.uploadFailList.forEach((item) => {
                if (item.errorCode !== null) {
                  let errorMessage = JSON.parse(item.errorMessage);
                  // itemMsg = errorMessage.detectedMessage + "\n\n";
                  if (length === 0) itemMsg = obj.$i18nUtil.trans("AB076") + "\n\n";
                  if (errorMessage.detectedFiles.length > 0) {
                    let detectedFiles = errorMessage.detectedFiles;
                    if (detectedFiles[0].data.length > 0) {
                      let detectedFilesData = detectedFiles[0].data;
                      for (let i = 0; i < detectedFilesData.length; i++) {
                        itemMsg += "\n- (" + detectedFilesData[i].pattern + ": " + detectedFilesData[i].count + "건) " + item.fileName;
                      }
                    }
                  }
                  length += 1;
                }
              });
              message += itemMsg;
              obj.hideLoadingbar();
              obj.showAlertDialog(message, null, {
                width: "600px",
              });
            }else {
              result.uploadList.forEach((item) => {
                const file = {
                  fileName: item.fileName,
                  fileExt: item.fileExt,
                  fileLink:
                    window.location.href.substring(
                      0,
                      window.location.href.lastIndexOf("reqFeedbackModal")
                    ) +
                    "fileDownload/" +
                    obj.feedbackInfo.paperInfo.groupId +
                    "/" +
                    item.fileId,
                    fileSize: item.fileSize,
                };
                obj.feedbackFileList.push(file);
              });
              if (obj.boardFiles.length == 0) {
                obj.requestFeedback();
              } else {
                obj.copyOutputToFeedback();
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    copyOutputToFeedback(snapshotPaperId) {
      let obj = this;
      let fileIds = [];
      this.boardFiles.forEach((item) => {
        fileIds.push(item.id);
      });
      let reqData = {
        url: "/api/cofile/paper/copyOutputToFeedback",
        method: "post",
        params: {
          groupId: this.feedbackInfo.paperInfo.groupId,
          paperId: this.feedbackInfo.paperInfo.paperId,
          feedbackPaperId: this.snapshotPaperId,
          fileIds: fileIds,
          sharepointSiteId: this.feedbackInfo.paperInfo.sharepointSiteId,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            res.result.result.forEach((item) => {
              const file = {
                fileName: item.fileName,
                fileExt: item.fileExt,
                fileLink:
                  window.location.href.substring(
                    0,
                    window.location.href.lastIndexOf("reqFeedbackModal")
                  ) +
                  "fileDownload/" +
                  obj.feedbackInfo.paperInfo.groupId +
                  "/" +
                  item.fileId,
                fileSize: item.fileSize,
              };
              obj.feedbackFileList.push(file);
            });
            obj.requestFeedback();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    feedbackChangeFile() {
      if (
        this.$refs.feedbackUploadfile.files == null ||
        this.$refs.feedbackUploadfile.files.length == 0
      ) {
        return;
      }
      let files = this.$refs.feedbackUploadfile.files;
      if (files.length) {
        for (let i = 0; i < files.length; i++) {
          this.files.push(files[i]);
          this.localFiles.push(files[i]);
        }
        console.log(this.files);
      }
      // this.opinionUpfile.files = [];
    },
    uploadBoardFile() {
      const modalInfo = {
        title: this.$i18nUtil.trans("title.FeedbackUploadFile.001","보드 내 최종결과물 추가"),
        width: "800px",
        obj: this.$modal,
        paperInfo: this.feedbackInfo.paperInfo,
        component: FeedbackUploadFile,
      };
      this.showModal(modalInfo);
    },
    confirmDelFile(_fileItem, _fileIndex) {
      let obj = this;
      obj.showConfirmDialog(
        { width: "400px" },
        obj.$i18nUtil.trans("title.dialog.notice","알림"),
        obj.$i18nUtil.trans("AB013"),
        obj.$i18nUtil.trans("button.dialog.delete","삭제"),
        obj.delFile,
        { fileItem: _fileItem, fileIndex: _fileIndex },
        obj.$i18nUtil.trans("button.dialog.cancel","취소"),
        null,
        "delFile"
      );
    },
    delFile(_data) {
      let _fileItem = _data.modalParam.fileItem;
      let _fileIndex = _data.modalParam.fileIndex;
      const obj = this;
      if (_fileItem.id) {
        obj.boardFiles.forEach((boardFile, boardFileIndex) => {
          if (_fileItem == boardFile) {
            obj.boardFiles.splice(boardFileIndex, 1);
          }
        });
      } else {
        obj.localFiles.forEach((localFile, localFileIndex) => {
          if (_fileItem == localFile) {
            obj.localFiles.splice(localFileIndex, 1);
          }
        });
      }
      obj.files.splice(_fileIndex, 1);
    },
    icoFile(fileName) {
      let str = fileName.substring(
        fileName.lastIndexOf(".") + 1,
        fileName.length
      );
      console.log(str);
      if (str == "pdf") {
        return "ico-file-pdf";
      } else if (str == "jpg" || str == "jpeg") {
        return "ico-file-jpg";
      } else if (str == "word") {
        return "ico-file-word";
      } else if (str == "png") {
        return "ico-file-png";
      } else if (str == "zip") {
        return "ico-file-zip";
      } else if (str == "gif") {
        return "ico-file-gif";
      } else if (str == "hwp") {
        return "ico-file-hwp";
      } else if (str == "ppt" || str == "pptx") {
        return "ico-file-ppt";
      } else if (str == "xlsx" || str == "xls") {
        return "ico-file-xlsx";
      } else if (str == "txt") {
        return "ico-file-txt";
      }
    },
  },
};
</script>

<style scoped>
  .bds076 .dropdown .dropdown-list-item {
    border: 0 none;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
    outline: none;
    position: relative;
    text-decoration: none;
  }

  .bds076 .box .row:first-child .dropdown.ty2 .v-btn {
    width: 155px;
  }
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/modal/ReqFeedbackModal.vue